<template>
  <div v-if="loaded">
    <div class="container h-100 content">
      <div class="d-flex justify-content-center h-100">
        <div class="login block link-block">
          <div>
            <h3>PrePayment Top-Up</h3>

            <div v-if="isError" class="alert-box" :class="error.class">
              <div class="title">
                {{ error.title }}
              </div>

              <p v-html="error.desc"></p>
            </div>

            <div v-else>
              <h4>Account Details</h4>
              <div class="account-block">
                <div class="title">PayPoint Number</div>
                <div class="item">{{ paymentData.paypoint }}</div>

                <div class="title">Current Balance</div>
                <div class="item">&pound;{{ paymentData.balance }}</div>
              </div>

              <h4>Make Payment</h4>

              <p>
                You can make full or partial payment below. Please ensure the
                details above match your account.
              </p>

              <PaymentChoice
                ref="paymentChoice"
                gtag-reference="PrePayCodeRequest"
                :debt-percent="paymentData.debt_percent"
                :allow-further-payment="false"
                multi-pay
                @handleRequest="requestPayment"
                @complete="resetPayment"
              ></PaymentChoice>

              <div class="footer-info">
                <p>
                  If you need any assistance please contact the customer
                  services team via our
                  <a href="https://dataenergy.co.uk/residents" target="_blank"
                    >Residents Hub</a
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { faSpinner, faAlignLeft } from "@fortawesome/free-solid-svg-icons";
import PaymentChoice from "@/views/Components/Payment/PaymentChoice.vue";

library.add(fas, faSpinner, faAlignLeft);

export default {
  name: "PayCodePayment",
  components: { PaymentChoice },
  props: {
    reference: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      loaded: false,
      paymentData: {},
      isError: false,
      error: {
        title: "",
        desc: "",
        class: ""
      },
      paymentComplete: false,
      paymentLoading: false
    };
  },
  computed: {
    env() {
      return process.env.VUE_APP_ENV;
    }
  },
  created() {
    this.$store.dispatch("loaderCancel");
    this.fetchData();
  },
  methods: {
    resetPayment() {
      this.paymentComplete = true;
    },
    requestPayment({ amount, paymentType }) {
      this.$store
        .dispatch("initiatePrePayCodePayment", {
          code: this.reference,
          verifier: this.paymentData.verifier,
          amount: amount,
          paymentType: paymentType
        })
        .then(response => {
          this.$gtag.event("payment", {
            event_category: "requestToPayByCode",
            event_label: amount
          });

          this.$nextTick(() => {
            this.$refs.paymentChoice.loadPayment(response.ref);
          });
        })
        .catch(err => {
          const title = "Payment Error";
          const subtitle = err;
          const samePage = true;
          this.$store.dispatch("pushError", { title, subtitle, samePage });
          this.$refs.paymentChoice.setPaymentError();
        })
        .finally(() => {
          this.paymentLoading = false;
        });
    },
    setError(title, desc, className) {
      this.error.title = title;
      this.error.desc = desc;
      this.error.class = className;
      this.isError = true;
    },
    clearError() {
      this.error.title = "";
      this.error.desc = "";
      this.error.class = "";
      this.isError = false;
    },
    fetchData() {
      this.clearError();
      const title = "Please Wait";
      const subtitle = "Getting payment details";
      this.$store.dispatch("loaderInitiate", { title, subtitle });

      this.$store
        .dispatch("getPrePayCodeRequest", { code: this.reference })
        .then(response => {
          this.paymentData = response;
        })
        .catch(error => {
          if (error === "Invalid apartment") {
            this.setError(
              "Meter Pending Activation",
              "Your meter has yet to be activated. We are in the process of setting this up and a letter will be sent to you once activated. <br><br><strong>NOTE:</strong> We will not disconnect your supply while in the setup stage.",
              "warning"
            );
          } else {
            this.setError(
              "Invalid Request",
              "Invalid link for payment. If this problem persists please contact us",
              "warning"
            );
          }
        })
        .finally(() => {
          this.loaded = true;
          this.$store.dispatch("loaderCancel");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.link-block {
  width: 650px;
  margin-top: 30px;
}

h2 {
  font-size: 1.6rem !important;
  text-align: left !important;
  margin-bottom: 10px !important;
  padding-left: 10px;
  margin-top: 20px;
}

p {
  color: #777;
  font-size: 0.9rem;
}

.payment-button {
  text-align: right;
  padding-top: 15px;
}

.link-block {
  width: 650px;
  margin-top: 30px;
}

.alert-box {
  padding: 20px;
  color: white;
  margin-bottom: 15px;
  margin-top: 20px;

  .title {
    font-weight: bold;
    padding-bottom: 20px;
    font-size: 1.2rem;
  }

  p {
    color: white;
  }

  &.danger {
    background-color: #ff7b71;
  }

  &.warning {
    background-color: #ff9800;
  }

  &.success {
    background-color: #83c45d;
  }
}

.paid-block {
  font-size: 1rem;
  color: #888;

  &.is-paid {
    font-size: 1.2rem;
    font-weight: bold;
    color: #444;
  }
}

h4 {
  margin-top: 25px;
}

.footer-info {
  margin-top: 40px;

  p {
    font-size: 0.8rem;
    color: #888;
    margin-bottom: 0px;
  }
}

.account-block {
  .title {
    font-size: 0.8rem;
    margin-top: 10px;
  }

  .item {
    font-weight: bold;
    font-size: 1.2rem;
  }
}
</style>
